import MoneyProto from '@square/dashboard-data/models/squareup/common/money-proto';
import ProcessingFeeAmounts from '@square/dashboard-data/models/squareup/beemo/api/v2/models/processing-fee-amounts';
import { ProtoBaseModel, attr } from '@square/dashboard-data/utils/ember-model-stubs';
export default ProtoBaseModel.extend({
  /**
   * The total money for all items and modifiers in this transaction.
   * The item prices do not reflect discounts.
   */
  productSalesMoney: attr(MoneyProto),
  /** Localized gross sale definition, rolled up from itemization level */
  grossSalesMoney: attr(MoneyProto),
  /** The total amount of discounts. This number is always negative. */
  discountMoney: attr(MoneyProto),
  /** The gross_sales_money + the discount_money (where discount_money is negative). */
  netSalesMoney: attr(MoneyProto),
  /** The total inclusive tax_money for this transaction.  */
  inclusiveTaxMoney: attr(MoneyProto),
  /** The total additive tax_money for this transaction.  */
  additiveTaxMoney: attr(MoneyProto),
  /** The total tax money (inclusive + additive) for this transaction.  */
  taxMoney: attr(MoneyProto),
  /** The total tip money of all tenders for this bill. */
  tipMoney: attr(MoneyProto),
  // NOTE: credit money is not specified here since that is not at the
  // original time of sale.

  /** The total collected amount for this transaction.  (net_sales + tax_money + tip_money)  */
  totalCollectedMoney: attr(MoneyProto),
  /** The total processing fees charged including AU GST. This number is always 0 or negative. */
  processingFeeMoney: attr(MoneyProto),
  /**
   * The net total.
   * Total collected + processing_fee_money (where processing fee money is negative)
   */
  netTotalMoney: attr(MoneyProto),
  /**
   * The total deposited money, i.e. the total collected money to pay out to merchants.
   * Total charged money + processing_fee_money (where processing fee money is negative)
   */
  totalDepositedMoney: attr(MoneyProto),
  /**
   * Total deposited money + free processing fee money
   */
  totalDepositedMoneyAfterFreeProcessing: attr(MoneyProto),
  /** Swedish rounding amount can be positive or negative **/
  swedishRoundingMoney: attr(MoneyProto),
  surchargeMoney: attr(MoneyProto),
  surchargeInclusiveTaxMoney: attr(MoneyProto),
  /** Gift card amount sold - gift card discounts */
  giftCardNetSalesMoney: attr(MoneyProto),
  /** This is the breakdown for processing_fee_money. These numbers are always 0 or negative. */
  processingFeeAmounts: attr(ProcessingFeeAmounts)
});